import { gql } from "@apollo/client";

export const FETCH_MMM_SUMMARY = gql`
  query FetchMmmSummary($cycleId: String!) {
    me {
      mmm {
        summary {
          accuracyData(cycleId: $cycleId) {
            data {
              date
              spend
              actualKpis
              predictedKpis
            }
          }
        }
      }
    }
  }
`;
